import type { Market } from '@backmarket/http-api'
import type { MarketCountryCode } from '@backmarket/http-api/src/api-models/MarketCountryCode'
import { useExperiments } from '@backmarket/nuxt-module-experiments/useExperiments'

import { getMarkets } from '../utils/getMarkets'

/** Get all available markets with experiment-aware locale support. */
export function useMarkets(): Record<MarketCountryCode, Market> {
  const experiments = useExperiments()
  const enableEsUsContent =
    experiments['experiment.enableEsUsContent'] !== 'disabled'

  return getMarkets(enableEsUsContent)
}
